// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"84":"39ebb016","884":"242200d1"}[chunkId] + ".chunk.js";
};